import React, { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Ticker } from "@/components/Ticker";
import { HeroCarousel } from "@/components/HeroCarousel";
import { ServiceGrid } from "@/components/ServiceGrid";
import { BookingModal } from "@/components/BookingModal";
import { ShieldCheck, Clock, Smartphone } from "lucide-react";

export default function Home() {
  const [service, setService] = useState(null);
  const [open, setOpen] = useState(false);

  const select = (s) => { setService(s); setOpen(true); };

  return (
    <div className="App">
      <Header />
      <Ticker />
      <HeroCarousel />

      <div className="bg-white border-b border-amber-100">
        <div className="max-w-7xl mx-auto px-4 py-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {[
            { icon: ShieldCheck, t: "Secure Booking", d: "Admin-verified confirmations" },
            { icon: Smartphone, t: "UPI Payments", d: "Scan QR or pay to UPI ID" },
            { icon: Clock, t: "24x7 Help Desk", d: "Call Center: 155 257" },
          ].map((x) => (
            <div key={x.t} className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-lg bg-[#FFF4E5] text-[#E65100] flex items-center justify-center"><x.icon className="w-5 h-5" /></div>
              <div>
                <div className="font-semibold text-amber-950 text-sm">{x.t}</div>
                <div className="text-xs text-slate-500">{x.d}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <ServiceGrid onSelect={select} />

      <BookingModal service={service} open={open} onClose={() => setOpen(false)} />
      <Footer />
    </div>
  );
}
